import { Checkbox } from '@pickleballinc/react-ui';
import { ChangeEvent } from 'react';

interface ApproveSchedulerMatchProps {
	onApprove: () => void;
	className?: string;
}

export const ApproveSchedulerMatch = ({ onApprove, className = '' }: ApproveSchedulerMatchProps) => {
	return (
		<div className={className}>
			<Checkbox
				theme="orange"
				className="size-4 cursor-pointer"
				onChange={(e: ChangeEvent<HTMLInputElement>) => {
					if (e.target.checked) {
						onApprove();
					}
				}}
			/>
			<p className="pl-2 font-medium">Approve all</p>
		</div>
	);
};
